// Centralised test IDs for Plantus landing page
export const NAV = {
  container: 'nav-container',
  logo: 'nav-logo',
  linkFeatures: 'nav-link-features',
  linkDemo: 'nav-link-demo',
  linkFaq: 'nav-link-faq',
  linkContact: 'nav-link-contact',
  ctaDownload: 'nav-cta-download',
};

export const HERO = {
  section: 'hero-section',
  heading: 'hero-heading',
  subtitle: 'hero-subtitle',
  ctaAppStore: 'hero-cta-appstore',
  ctaPlayStore: 'hero-cta-playstore',
  ctaApk: 'hero-cta-apk',
  mockup: 'hero-mockup',
};

export const FEATURES = {
  section: 'features-section',
  card: (key) => `features-card-${key}`,
};

export const DEMO = {
  section: 'demo-section',
  shot: (i) => `demo-shot-${i}`,
};

export const FAQ = {
  section: 'faq-section',
  item: (i) => `faq-item-${i}`,
  trigger: (i) => `faq-trigger-${i}`,
};

export const CONTACT = {
  section: 'contact-section',
  form: 'contact-form',
  name: 'contact-name-input',
  email: 'contact-email-input',
  org: 'contact-org-input',
  message: 'contact-message-input',
  submit: 'contact-submit-button',
  success: 'contact-success-message',
};

export const CTA_BOTTOM = {
  section: 'cta-bottom-section',
  appstore: 'cta-bottom-appstore',
  playstore: 'cta-bottom-playstore',
  apk: 'cta-bottom-apk',
};

export const FOOTER = {
  container: 'footer-container',
  impressum: 'footer-impressum',
  privacy: 'footer-privacy',
  contact: 'footer-contact',
};
